module.exports = __webpack_public_path__ + "img/spades.0d2d5459.png";